module.exports = __webpack_public_path__ + "static/imgs/box.0d0e1ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/box.png
// module id = Ju0z
// module chunks = 1